import { requestManager } from '../../requestManager';

import { API_PATH } from '../../config/config';

class ChangeComplete {
  /**
   * 受付データ取得
   * @param {Number} receptionId 受付ID
   * @return {Promise<Object>} 受付データ
   */
  getReception = async (receptionId) => {
    const result = await requestManager.post(`${API_PATH}/changecmplt/r`, {
      receptionId,
    });
    return result.data;
  };

  getRsvSetting = async (rsvSetId = null) => {
    const filter = { rsv_set_id: rsvSetId, enable: true };
    const params = { filter };
    const result = await requestManager.get(`${API_PATH}/changecmplt/r/reserve-setting`, params);
    return result.data;
  };

  /**
   * メールの再送
   * @param {number} receptionId
   * @returns
   */
  resendMail = async (receptionId) => {
    const result = await requestManager.put(`${API_PATH}/changecmplt/u/resend-mail`, {
      receptionId,
    });
    return result.data;
  };

  /**
   * SMSの再送
   * @param {number} receptionId
   * @returns
   */
  resendSms = async (receptionId) => {
    const result = await requestManager.put(`${API_PATH}/changecmplt/u/resend-sms`, {
      receptionId,
    });
    return result.data;
  };

  /**
   * メールアドレスの更新（変更して再送）
   * @param {number} receptionId
   * @param {string} newMailAddress
   * @returns
   */
  updateMail = async (receptionId, newMailAddress) => {
    const result = await requestManager.put(`${API_PATH}/changecmplt/u/update-mail-address`, {
      receptionId,
      newMailAddress,
    });
    return result.data;
  };

  /**
   * 電話番号の更新（変更して再送）
   * @param {number} receptionId
   * @param {string} newTelNum
   * @returns
   */
  updateSms = async (receptionId, newTelNum) => {
    const result = await requestManager.put(`${API_PATH}/changecmplt/u/update-tel-num`, {
      receptionId,
      newTelNum,
    });
    return result.data;
  };
}

export default new ChangeComplete();
